export const getMobileColumns = (columns: any[]) =>
  columns.map((c) => ({ ...c, label: c.shortLabel || c.label }));
